import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Shell } from "@/components/Shell";

export const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <p className="overline">Loading loop</p>
      </div>
    );
  if (!user) return <Navigate to="/" replace />;
  return <Shell>{children}</Shell>;
};
